module.exports = require("@swa-ui/chase/src/ChaseFriendReferral/ChaseFriendReferral.module.scss");